'use strict';
const mmWidgets = require('./mm-widgets');
require('./google-migration-list-item-widget');
mmWidgets.fn.googleMigrationListWidget = function (googleMigrationModel) {
	return mmWidgets.each(this, function () {
		const element = this,
			listContainer = element.find('[data-mm-role~="fileListContainer"]'),
			template = element.find('[data-mm-role~="file-list-template"]').detach();
		element.addClass('hidden');
		googleMigrationModel.addEventListener('context', context => {
			listContainer.empty();
			if (context && context.selectedFiles && context.selectedFiles.length) {
				element.removeClass('hidden');
				context.selectedFiles.forEach((selectedFile) => {
					template.clone()
					.googleMigrationListItemWidget(selectedFile)
					.appendTo(listContainer);
				});
			} else {
				element.addClass('hidden');
			}
			element.trigger('context-end');
		});
	});
};
